export const parseResult = async (response: Response) => {
  const contentDisposition = response.headers.get('Content-Disposition')

  if (contentDisposition?.includes('attachment')) {
    return response.blob()
  }

  const contentType = response.headers.get('Content-Type')

  if (contentType?.includes('application/json')) {
    return response.json()
  }

  return response.text()
}
